import { Button } from "@web/components/ui/button";
import { useLanguage } from "@web/lib/contexts/language-context";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router";

type QrCodeNotFoundError = {
	isUsingQueryEntry: boolean;
	retakePhoto: () => void;
};

export const QrCodeNotFoundError = (props: QrCodeNotFoundError) => {
	const navigate = useNavigate();
	const { isUsingQueryEntry, retakePhoto } = props;
	const { t } = useLanguage();

	return (
		<motion.div className="fixed inset-0 flex flex-col items-center justify-center bg-black p-6">
			<div className="w-full max-w-md rounded-lg bg-yellow-50 p-6 text-yellow-800">
				<div className="flex items-center">
					<AlertTriangle className="mr-2 h-6 w-6" />
					<p className="text-lg font-medium">{t.camera.qrCodeNotFound}</p>
				</div>
				<p className="mt-2">
					{isUsingQueryEntry
						? t.camera.qrCodeNotFoundWithEntry
						: t.camera.qrCodeNotFoundGeneric}
				</p>
				<div className="mt-4 flex gap-3">
					<Button
						variant="outline"
						className="border-yellow-300 text-yellow-800 hover:bg-yellow-100 bg-transparent"
						onClick={retakePhoto}
					>
						{t.common.retry}
					</Button>
					<Button onClick={() => navigate(-1)}>{t.common.back}</Button>
				</div>
			</div>
		</motion.div>
	);
};
